import { dropAssetIntoBucket } from 'owa-timestream-asset-sdk-bucket';
import { orchestrator, mutator } from 'satcheljs';
import { startDraggingAssets } from '../actions';
import {
    updateAssetParent,
    removeBucketChild,
    moveTimeStreamAsset,
    getAsset,
    getLocalAssetId,
    getSelectedProjectId,
} from 'owa-timestream-store';
import getPanAndZoom from '../selectors/getPanAndZoom';
import getStore from '../store';
import getSelectedAssets from '../selectors/getSelectedAssets';

mutator(startDraggingAssets, function updateBucketChildrenPositions() {
    // 20px is the padding from the parent, getBoundingClientRect doesn't grab it
    const assetDefaultPadding = 20;
    const projectId = getSelectedProjectId();
    const selectedAssets = getSelectedAssets();
    const { zoom } = getPanAndZoom();
    for (const assetId of selectedAssets) {
        const { bounds, parentId, outlookSpaceAssetId } = getAsset(projectId, assetId);
        if (parentId) {
            const parentAsset = getAsset(projectId, parentId);

            const parentElement =
                document.getElementById(parentId) ||
                document.getElementById(getLocalAssetId(parentAsset.outlookSpaceAssetId!)!)!;

            const assetElement =
                document.getElementById(assetId) ||
                document.getElementById(getLocalAssetId(outlookSpaceAssetId!)!)!;

            const parentBounds = parentElement.getBoundingClientRect();
            const assetBounds = assetElement.getBoundingClientRect();

            const yDiff = assetBounds.top - parentBounds.top;
            bounds.x = parentAsset.bounds.x + assetDefaultPadding;
            bounds.y = parentAsset.bounds.y + yDiff / zoom + assetDefaultPadding;
        }
    }
});

orchestrator(dropAssetIntoBucket, ({ projectId, bucketAssetId, order }) => {
    // We should think about updating these items with a single network call.
    const { selectedAssets } = getStore();
    const lastAssetIndex = selectedAssets.length - 1;
    selectedAssets.forEach((assetId, index) => {
        const { type } = getAsset(projectId, assetId);
        if (type !== 'bucket') {
            updateAssetParent(projectId, assetId, bucketAssetId, order, index == lastAssetIndex);
            removeBucketChild(projectId, assetId, true /* movedIntoBucket */);
        }
    });
});

orchestrator(moveTimeStreamAsset, ({ projectId, assetId }) => {
    removeBucketChild(projectId, assetId, false /* movedIntoBucket */);
});
